import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.function.name.js";
import { trackCxFoundationsHcArticleFromContactUsClick } from "@faire/web-api/events/cxFoundations/click/hcArticleFromContactUs";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
export var SuggestedArticle = function SuggestedArticle(_ref) {
  var id = _ref.id,
    name = _ref.name,
    getPreview = _ref.getPreview,
    getLink = _ref.getLink;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    preview = _useState2[0],
    setPreview = _useState2[1];
  useEffect(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }
    function _fetchData() {
      _fetchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPreview();
            case 2:
              response = _context.sent;
              setPreview(response !== null && response !== void 0 ? response : "");
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }
    fetchData();
  }, [getPreview]);
  var trackClickOnArticle = function trackClickOnArticle() {
    trackCxFoundationsHcArticleFromContactUsClick(id, name);
  };
  return /*#__PURE__*/React.createElement(Column, {
    align: "flex-start"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: getLink(),
    onClick: trackClickOnArticle,
    target: "__blank"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, name)), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(PreviewContainer, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "labelSansRegular"
  }, preview)));
};
var PreviewContainer = styled.div.withConfig({
  displayName: "SuggestedArticle__PreviewContainer"
})(["display:-webkit-box;width:100%;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"]);